import { toast } from "react-toastify";
import { UPLOAD_MULTIPLE_FILES } from "../services/ApiCalls";

export default async (files) => {
  try {
    if (!files || files.length === 0) return;

    const allowedExtensions = ["svg", "jpg", "png", "jpeg"];
    const formData = new FormData();

    for (const file of files) {
      const fileType = file.type.split("/")[1];

      if (!allowedExtensions.includes(fileType)) {
        toast.error(
          "Unsupported file type. Only SVG, JPG, PNG, and JPEG files are allowed."
        );
        return;
      }

      // 👇 use same key for multiple files
      formData.append("images", file);
    }

    const res = await UPLOAD_MULTIPLE_FILES(formData);

    if (res?.data?.status === "success") {
      return res?.data?.data;
    } else {
      toast.dismiss();
      toast.error(res?.data?.message || "Upload failed");
      return false;
    }
  } catch (error) {
    toast.dismiss();
    toast.error("Something went wrong while uploading images");
    console.error(error);
  }
};
